/**
 * BudgetSettingService
 * Singleton service configuration row (get + partial update).
 * Route: api/budget-settings
 */
export class BudgetSettingService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? BudgetSettingService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${BudgetSettingService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** The singleton settings row. */
    async get() {
        const response = await this.http.get(this.buildUrl());
        if (!response.data)
            throw new Error('Budget settings not found');
        return response.data;
    }
    /** Partial update of the singleton settings row. */
    async update(body) {
        const response = await this.http.put(this.buildUrl(), body);
        if (!response.data)
            throw new Error('Failed to update budget settings');
        return response.data;
    }
}
BudgetSettingService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetSettingService.BASE_PATH = 'api/budget-settings';
//# sourceMappingURL=BudgetSettingService.js.map